declare const PACKAGE_CURRENT_VERSION: string | undefined

export const VERSION: string = PACKAGE_CURRENT_VERSION || "TESTVERSION"
